/* Cross-document photo transitions. All links retain the browser's native navigation. */
(() => {
  if (window.LRSPageTransitions) return;
  window.LRSPageTransitions = true;
  if (!('onpageswap' in window) || !('onpagereveal' in window) || !window.CSS?.supports('view-transition-name', 'lrs-vehicle-image')) return;

  const storageKey = 'lrs:vehicle-transition';
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const root = document.documentElement;
  let pending = null;
  let temporary = [];

  const enabled = () => !motion.matches && document.body?.dataset.lrsMotion !== 'false' && !window.Shopify?.designMode;
  const pageURL = value => {
    if (typeof value !== 'string' || !value) return '';
    try {
      const url = new URL(value, location.href);
      return url.origin === location.origin ? url.origin + url.pathname.replace(/\/$/, '') + url.search : '';
    } catch (_) { return ''; }
  };
  const clearRecord = () => { try { sessionStorage.removeItem(storageKey); } catch (_) { /* Storage can be disabled. */ } };
  const cleanup = () => {
    temporary.forEach(([element, value]) => { element.style.viewTransitionName = value; });
    temporary = [];
    root.classList.remove('lrs-vehicle-transition');
  };
  const name = (element, value) => {
    if (!element) return;
    temporary.push([element, element.style.viewTransitionName]);
    element.style.viewTransitionName = value;
  };
  const visible = element => {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
  };
  const settle = transition => {
    // ready rejects when an outgoing document is hidden; consume it deliberately.
    transition.ready?.catch(() => {});
    transition.finished.then(cleanup, cleanup);
  };
  const skip = transition => { clearRecord(); cleanup(); transition?.skipTransition(); };

  document.addEventListener('click', event => {
    pending = null;
    if (!enabled() || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const anchor = event.target.closest?.('a[data-vehicle-transition-link][href]');
    if (!anchor || anchor.hasAttribute('download') || (anchor.target && anchor.target !== '_self')) return;
    const target = new URL(anchor.href, location.href);
    if (target.hash || !/^https?:$/.test(target.protocol)) return;
    const destination = pageURL(target.href);
    if (!destination || destination === pageURL(location.href)) return;
    const card = anchor.closest('[data-vehicle-transition-card]');
    const image = card?.querySelector('img');
    if (!image?.complete || !image.naturalWidth || !visible(image)) return;
    pending = { image, from: pageURL(location.href), to: destination, at: Date.now() };
  });

  window.addEventListener('pageswap', event => {
    const transition = event.viewTransition;
    if (!transition) { pending = null; clearRecord(); return; }
    const selected = pending;
    pending = null;
    if (!enabled() || !selected || Date.now() - selected.at > 15000 || pageURL(event.activation?.entry?.url) !== selected.to || !visible(selected.image)) {
      skip(transition); return;
    }
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({ from: selected.from, to: selected.to, at: Date.now() }));
    } catch (_) { skip(transition); return; }
    cleanup();
    root.classList.add('lrs-vehicle-transition');
    name(selected.image, 'lrs-vehicle-image');
    settle(transition);
  });

  window.addEventListener('pagereveal', event => {
    const transition = event.viewTransition;
    let record;
    try { record = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (_) { record = null; }
    clearRecord();
    if (!transition) { cleanup(); return; }
    const activation = window.navigation?.activation;
    const from = pageURL(activation?.from?.url || document.referrer);
    const target = document.querySelector('[data-vehicle-transition-image]');
    const image = target?.matches('img') ? target : target?.querySelector('img');
    if (!enabled() || !record || Date.now() - record.at > 15000 || record.to !== pageURL(location.href) || record.from !== from || activation?.navigationType === 'traverse' || !visible(image)) {
      skip(transition); return;
    }
    cleanup();
    root.classList.add('lrs-vehicle-transition');
    name(image, 'lrs-vehicle-image');
    const title = document.querySelector('[data-vehicle-transition-title]');
    title?.classList.add('is-visible');
    name(title, 'lrs-vehicle-title');
    name(document.querySelector('[data-vehicle-transition-details]'), 'lrs-vehicle-details');
    settle(transition);
  });

  window.addEventListener('pageshow', event => { if (event.persisted) { pending = null; cleanup(); } });
  motion.addEventListener?.('change', () => { if (motion.matches) { pending = null; clearRecord(); document.activeViewTransition?.skipTransition(); cleanup(); } });
})();
